import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';
import { useParams } from "react-router-dom";
import html2pdf from 'html2pdf.js';
import { IoClose } from 'react-icons/io5';
import PurchaseReceivedPDF from "./PurchaseReceivedPDF";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "90%",
        maxWidth: "90%",
    },
};

function PurchanseOrderDetails() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const { id } = useParams();
    const [orderList, setOrderList] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetails, setOrderDetails] = useState("");
    const [productList, setProductList] = useState([]);
    const [text, setText] = useState('');
    const [value] = useDebounce(text, 1000);

    const pdfRef = useRef();

    useEffect(() => {
        // Call API with the order ID
        fetchOrderDetails(id);
    }, [id]);

    async function fetchOrderDetails(orderId) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getPurchaseOrderDetails?purchaseOrderId=${orderId}`);
        // const tempData = await res.json();
        setIsLoadingOn(false);
        // console.log("tempData++++", tempData)
        if (tempData?.statusCode === 200) {
            const records = tempData?.data;
            console.log(records)
            setProductList(records);
            setOrderDetails(records[0]);
            setSelectedOrder(records[0])
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    async function getPurchaseOrder(typeValue) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getPurchaseOrder?vendorName=${typeValue || ''}`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;
            if (Array.isArray(records)) {
                setOrderList(records);
            } else {
                setOrderList([]);
            }
        } else {
            setOrderList([]); // ensure orderList is not undefined
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    // Debounced search
    useEffect(() => {
        getPurchaseOrder(value); // if empty string, returns all
    }, [value]);

    const totals = productList.reduce(
        (acc, item) => {
            const qty = Number(item?.quantity) || 0;
            const rate = Number(item?.rate) || 0;
            const discount = Number(item?.discount) || 0;
            const itemTotal = qty * rate - discount;
            const totalGst = Number(item.gst) || 0

            acc.totalQuantity += qty;
            acc.subTotal += qty * rate;
            acc.totalDiscount += discount;
            acc.total += itemTotal;
            acc.totalWithGst += totalGst;

            return acc;
        },
        { totalQuantity: 0, subTotal: 0, totalDiscount: 0, total: 0, totalWithGst: 0 }
    );

    // 👉 Now calculate GST separately based on subtotal
    const gstAmount = (totals.subTotal * 18) / 100;

    // 👉 Final total including GST
    const grandTotal = totals.total + gstAmount;


    const generatePDF = () => {
        const element = pdfRef.current;
        if (!element) {
            console.error('PDF element not found!');
            return;
        }

        html2pdf()
            .from(element)
            .set({
                margin: 0.1,
                filename: `PurchaseOrder_${orderDetails?.purchaseOrder || 'PO'}.pdf`,
                html2canvas: { scale: 3 },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
            })
            .save();
    };



    return (
        <div className="purchaseOrderDetails" style={{ backgroundColor: "#fff", marginLeft: "-20px" }}>
            {isLoadingOn ? <Loader /> : ""}
            <div className="row ordersec">
                <div className="col-sm-3 lfsec pd0">
                    <div className="ps-3 pt-3 pb-3 d-flex justify-content-between">
                        <h5>All Purchase Orders</h5>
                        <Link to={'/purchase/new'}>
                            <button className="btn btn-primary mx-2">
                                + New
                            </button>
                        </Link>
                    </div>
                    {
                        orderList.map((item, index) => {
                            const isSelected = selectedOrder?.purchaseOrderId === item?.purchaseOrderId;

                            return (
                                <div
                                    className={`lfheader d-flex ${isSelected ? 'selected' : ''}`}
                                    key={index}
                                    onClick={() => {
                                        setSelectedOrder(item);
                                    }}
                                >
                                    <Link to={`/purchaseorderDetails/${item.purchaseOrderId}`} className="d-flex justify-content-between w-100">
                                        <div className="ms-3">
                                            <div className="hd">{item?.vendorNme}</div>
                                            <div className="podate">{item?.purchaseOrder} <span className="mx-3">-</span> {item?.date}</div>
                                            <div className="orderStatus">{item?.statusName}</div>
                                        </div>
                                        <div className="ms-auto amount">
                                            Rs.{item?.orderTotal ? Number(item.orderTotal).toFixed(2) : '0.00'}
                                        </div>
                                    </Link>
                                </div>
                            )
                        })
                    }
                </div>


                <div className="col-sm-9 rtsec pd0">
                    {orderDetails && (
                        <div className="ps-4 pt-3 pb-3 d-flex">
                            <h5>{orderDetails.purchaseOrder}</h5>
                            <div className="ms-auto">
                                <Link to={'/purchaseorder'}><IoClose size={24} style={{ cursor: "pointer", color: "#666" }} /></Link>
                            </div>
                        </div>
                    )}
                    <ul className="d-flex">
                        <li onClick={() => window.open(`/purchase/update/${id}`, '_blank')} style={{ cursor: 'pointer' }}>Edit</li>
                        <li>Send Email</li>
                        <li>PDF/Print</li>
                        <li>Receive</li>
                        <li>Convert to Bill</li>
                        <li>:</li>
                    </ul>
                    <div className="scroll-y noscroll-x fill body scrollbox" id="orderDetailsContainer" style={{ paddingTop: 0 }}>
                        {orderDetails && (
                            <div className="row">
                                <div className="col-sm-12">
                                    <button className="pdfbtn btn btn-outline-primary ms-auto d-flex" onClick={generatePDF}>Download PO</button>
                                    <div style={{ display: 'none' }}>
                                        <div ref={pdfRef} style={{ paddingTop:"10px"}}>
                                            <PurchaseReceivedPDF orderDetails={orderDetails} productList={productList} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6 lfsecpdf">
                                    <h3 className="text-uppercase">Purchase Order</h3>
                                    <div className="so-number">
                                        <label className="font-small">Purchase Order#</label>
                                        <label className="font-small"><strong>{orderDetails?.purchaseOrder}</strong></label>
                                    </div>
                                    <div>
                                        <label className="text-uppercase text-semibold badge badge-so badge-open">{orderDetails?.statusName}</label>
                                    </div>
                                    <div className="order-info">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <h6 className="text-uppercase"><strong>Reference#</strong></h6>
                                            </div>
                                            <div className="col-lg-6 so-details-label">{orderDetails?.reference}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <h6 className="text-uppercase"><strong>Order Date</strong></h6>
                                            </div>
                                            <div className="col-lg-6 so-details-label">{orderDetails?.date}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <h6 className="text-uppercase"><strong>Delivery Date</strong></h6>
                                            </div>
                                            <div className="col-lg-6 so-details-label">{orderDetails?.deliveryDate}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4"><h6 className="text-uppercase"><strong>Payment Terms</strong></h6></div>
                                            <div className="col-lg-6 so-details-label wordwrap">{orderDetails?.paymentTerms}</div></div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 rtsecpdf">
                                    <div className="address">
                                        <h6 className="text-uppercase"><strong>Vendor Address</strong>

                                        </h6>
                                        {/* <label><a id="ember303" className="ember-view" href="#">{orderDetails?.deliveryAddress}</a></label> */}
                                        <div>{orderDetails?.ShopNumberAndBuildingName}</div>
                                        <div><span>{orderDetails?.address1}</span> {orderDetails?.city}</div>
                                        <div><span>{orderDetails?.state}</span> {orderDetails?.shopPinCode}</div>
                                    </div>
                                    <div className="address mt-5">
                                        <h6 className="text-uppercase"><strong>Delivery Address</strong></h6>
                                        <address>{orderDetails?.deliveryAddress}</address>
                                        {/* <address>Swapnil Shirawale <br />Maharashtra <br /> India <br /> </address> */}
                                    </div>


                                </div>
                            </div>
                        )}
                        <div className="orderTable">
                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Items & Description	</th>
                                        <th>Color</th>
                                        <th>Ordered</th>
                                        <th>Status</th>
                                        <th className="text-right">Rate</th>
                                        <th className="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(productList) &&
                                        productList.map((item, index) => (
                                            <>
                                                <tr>
                                                    <td>
                                                        <div>{item?.productName}</div>
                                                        {/* <div>SKU 10</div> */}
                                                    </td>
                                                    <td>{item?.color ?? ""}</td>
                                                    <td>
                                                        <div>{item?.quantity}</div>
                                                        {/* <div>Box</div> */}
                                                    </td>
                                                    <td>
                                                        <div>{item?.received}</div>
                                                        <div>{item?.billed}</div>
                                                    </td>
                                                    <td>Rs.{item?.rate != null ? Number(item.rate).toFixed(2) : "0.00"}</td>
                                                    <td>{item?.amount != null ? Number(item.amount).toFixed(2) : "0.00"}</td>
                                                </tr>
                                            </>
                                        ))
                                    }

                                </tbody>
                            </table>
                            <div className="group mt-5">
                                <div className="row">
                                    <div className="col-lg-6 col-md-9 ms-auto sub-total-section">
                                        <div className="">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6">
                                                    <strong className="subtotal">Sub Total</strong>
                                                    <div className="font-xs text-muted">Total Quantity : {totals?.totalQuantity}</div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 over-flow">
                                                    <strong className="subtotal">Rs.{orderDetails?.orderTotal != null ? Number(orderDetails?.orderTotal).toFixed(2) : "0.00"}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="row text-muted discountsec">
                                                <div className="col-lg-6 col-md-6">
                                                    <span className="dishd">GST (18%)</span>
                                                </div>
                                                <div className="col-lg-6 col-md-6 over-flow">
                                                    <span className="dishd">Rs.{orderDetails?.gstAmount != null ? Number(orderDetails?.gstAmount).toFixed(2) : "0.00"}</span>
                                                </div>
                                            </div>

                                            <div className="row text-muted discountsec">
                                                <div className="col-lg-6 col-md-6">
                                                    <span className="dishd">Discount</span>
                                                </div>
                                                <div className="col-lg-6 col-md-6 over-flow">
                                                    <span className="dishd">Rs.{orderDetails?.discountAmount ? orderDetails?.discountAmount : 0}</span>
                                                </div>
                                            </div>
                                            <div className="row text-muted discountsec">
                                                <div className="col-lg-6 col-md-6">
                                                    <span className="dishd">Adjustment</span>
                                                </div>
                                                <div className="col-lg-6 col-md-6 over-flow">
                                                    <span className="dishd">Rs.{orderDetails?.adjustmentAmount ? orderDetails?.adjustmentAmount : 0}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <strong className="subtotal">Total</strong>
                                            </div>
                                            <div className="col-lg-6 col-md-6 over-flow">
                                                <strong className="subtotal">Rs.{orderDetails?.orderTotalWithDiscount != null ? Number(orderDetails?.orderTotalWithDiscount).toFixed(2) : "0.00"}</strong>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default PurchanseOrderDetails;
